<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-actions class="dialog-action">
  <button mat-button (click)="onRespond(true)">{{ agreeLabel }}</button>
  <button mat-button (click)="onRespond(false)">{{ disagreeLabel }}</button>
</div>
